//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SubscribeHero2026',
  components: {
    SubscribeHeroBanner: () => import('@/components/subscribe/SubscribeHeroBanner.vue'),
    SubscribeHero2026Heading: () => import('@/components/subscribe2026/SubscribeHero2026Heading.vue'),
    SubscribeHero2026Stats: () => import('@/components/subscribe2026/SubscribeHero2026Stats.vue'),
    SubscribeHero2026SoftwareBadges: () => import('@/components/subscribe2026/SubscribeHero2026SoftwareBadges.vue'),
    SubscribeHero2026PromoVideo: () => import('@/components/subscribe2026/SubscribeHero2026PromoVideo.vue'),
    SubscribeHero2026AiPartners: () => import('@/components/subscribe2026/SubscribeHero2026AiPartners.vue'),
    SubscribeForm2026: () => import('@/components/subscribe2026/SubscribeForm2026.vue'),
  },
  data() {
    return {
      bgImagePath: '/img/subscribe/hero-product-feed.260521.png',
    };
  },
};
